<script>
export default {
    name: "PatientDischargeDetails",

    props: {

        patient: {
            type: Object,
            required: true,
        },
        showModal: {
            type: Boolean,
            required: true,
        },
        dischargeDetails: {
            type: Object,
            required: true,
        },
        routeParams: {
            type: Object,
            required: true,
        },
    },

    computed: {

        totalBedCharges() {
            if(!this.dischargeDetails) return 0;

            if(!this.dischargeDetails.patientWardCharges) return 0;

            if(!this.dischargeDetails.patientWardCharges.length) return 0;
            
            return this.dischargeDetails.patientWardCharges
                .map(wCharge => wCharge.amount ? parseFloat(wCharge.amount) : parseFloat(0))
                .reduce((sum, amt) => sum+amt);
        },

        totalDrugsAndServices() {

            if(!this.dischargeDetails) return 0;

            if(!this.dischargeDetails.patientDrugsnService) return 0;

            if(!this.dischargeDetails.patientDrugsnService.length) return 0;

            return this.dischargeDetails.patientDrugsnService
                .map(drugCharges => drugCharges.grandTotal ? parseFloat(drugCharges.grandTotal) : parseFloat(0))
                .reduce((sum, amt) => sum+amt);
        },

        totalBill() {

            return this.totalDrugsAndServices;
        },

        totalDeposits() {
            if(!this.dischargeDetails) return 0;
            
            if(!this.dischargeDetails.patientsDeposits) return 0;

            if(!this.dischargeDetails.patientsDeposits.length) return 0;
            
            return this.dischargeDetails.patientsDeposits.map(dep => 
                dep.depositAmount ? parseFloat(dep.depositAmount) : parseFloat(0))
                .reduce((sum, amt) => sum+amt);
        },

        totalDepositAllocated() {
            if(!this.dischargeDetails) return 0;
            
            if(!this.dischargeDetails.patientsDeposits) return 0;

            if(!this.dischargeDetails.patientsDeposits.length) return 0;
            
            return this.dischargeDetails.patientsDeposits.map(dep => 
                dep.amountAllocated ? parseFloat(dep.amountAllocated) : parseFloat(0))
                .reduce((sum, amt) => sum+amt);
        },

        totalDepositUnallocated() {
            if(!this.dischargeDetails) return 0;
            
            if(!this.dischargeDetails.patientsDeposits) return 0;

            if(!this.dischargeDetails.patientsDeposits.length) return 0;
            
            return this.dischargeDetails.patientsDeposits.map(dep => 
                    dep.unAllocatedAmount ? parseFloat(dep.unAllocatedAmount) : parseFloat(0))
                .reduce((sum, amt) => sum+amt);
        },

        totalPayments() {

            if(!this.dischargeDetails) return 0;

            if(!this.dischargeDetails.patientsPayments) return 0;

            if(!this.dischargeDetails.patientsPayments.length) return 0;

            return this.dischargeDetails.patientsPayments
                .map(payment => payment.receiptAmount ? parseFloat(payment.receiptAmount) : parseFloat(0))
                .reduce((sum, amt) => sum+amt);
        },

        totalPaidAmt() {

            if(!this.dischargeDetails) return 0;

            if(!this.dischargeDetails.patientDrugsnService) return 0;

            if(!this.dischargeDetails.patientDrugsnService.length) return 0;

            return this.dischargeDetails.patientDrugsnService
                .map(drugCharges => drugCharges.paid ? parseFloat(drugCharges.paid) : parseFloat(0))
                .reduce((sum, amt) => sum+amt);
        },

        totalDSBalance() {

            if(!this.dischargeDetails) return 0;

            if(!this.dischargeDetails.patientDrugsnService) return 0;

            if(!this.dischargeDetails.patientDrugsnService.length) return 0;

            return this.dischargeDetails.patientDrugsnService
                .map(drugCharges => drugCharges.balance ? parseFloat(drugCharges.balance) : parseFloat(0))
                .reduce((sum, amt) => sum+amt);
        },

        totalPaymentReceived() {
            if(!this.dischargeDetails) return 0;

            if(!this.dischargeDetails.patientsPayments) return 0;

            if(!this.dischargeDetails.patientsPayments.length) return 0;

            return this.dischargeDetails.patientsPayments.map(payment => parseFloat(payment.receiptAmount))
                .reduce((sum,amt) => sum+amt);
        },

        totalWaiver() {
            if(!this.dischargeDetails) return 0;

            if(!this.dischargeDetails.patientsWeivers) return 0;

            if(!this.dischargeDetails.patientsWeivers.length) return 0;

            return this.dischargeDetails.patientsWeivers
                    .map(waiver => parseFloat(waiver.weiveredAmount))
                    .reduce((sum,amt) => sum+amt);
        },

        totalOrganizationReceipts() {
            if(!this.dischargeDetails) return 0;

            if(!this.dischargeDetails.patientOrganReceipts) return 0;

            if(!this.dischargeDetails.patientOrganReceipts.length) return 0;

            return this.dischargeDetails.patientOrganReceipts
                    .map(orgPayment => parseFloat(orgPayment.amount))
                    .reduce((sum,amt) => sum+amt);
        },

        totalBalance() {

            return this.totalBill - this.totalPaidAmt;
        },
    },

    methods: {

        printInterimBill() {
            let url = `/admissions/discharge-patient-bill`;
                url += `?patientID=${this.routeParams.patientID}`;
                url += `&visitNo=${this.routeParams.visitNO}`;

            window.open(url, 
                '_blank', 
                `ReportPrint`, 
                "menubar=yes,location=yes,resizable=yes,scrollbars=yes,status=yes");
        },
    },

}
</script>
<template>
<tail-modal :show="showModal" dimension="w-11/12 md:w-3/4">
  <template v-slot:title>
    <h5 class="font-bold text-base">Patient Hospital Bill Summary</h5>
  </template>
  <template v-slot:modal-body>
    <div class="flex flex-wrap bg-blue-500 text-white">
        <div class="md:w-1/4 w-1/2 p-tiny">
            <h5 class="font-medium">Name: {{ patient.names }}</h5>
        </div>
        <div class="md:w-1/4 w-1/2 p-tiny">
            <h5 class="font-medium">MRN: {{ patient.patientID || patient.patienT_ID }}</h5>
        </div>
        <div class="md:w-1/4 w-1/2 p-tiny">
            <h5 class="font-medium">IP No: {{ patient.ipfileno || `-` }}</h5>
        </div>
        <div class="md:w-1/4 w-1/2 p-tiny">
            <h5 class="font-medium">OP No: {{ patient.opfileno || `-` }}</h5>
        </div>
        <div class="md:w-1/4 w-1/2 p-tiny">
            <h5 class="font-medium">Admitted On: 
                {{ dischargeDetails.patientWardCharges.length ? 
                    $root.formatDate(dischargeDetails.patientWardCharges[0].bedDateIn) : `-` }}
            </h5>
        </div>
        <div class="flex-1 p-tiny">
            <h5 class="font-medium">Discharged On: 
                {{ dischargeDetails.patientWardCharges.length ? 
                    $root.formatDate(dischargeDetails.patientWardCharges[0].bedDateOut) : `-` }}
            </h5>
        </div>
    </div>
    <div class="w-full p-tiny my-px">
        <h5 class="font-bold text-sm">Payment Mode: 
            <span class="text-blue-600">{{ patient.pmode }}</span></h5>
    </div>
   <div class="w-full text-center p-1">
        <h5 class="font-bold text-base">
            <input type="checkbox" class="mr-2" v-if="patient.special" :value="true" v-model="patient.special">
                Ward Charges</h5>
    </div>
    <div class="overflow-auto">
        <table class="table">
            <thead class="bg-blue-500 text-white text-sm">
                <tr>
                    <th class="p-tiny">Ward Type</th>
                    <th class="p-tiny">Ward</th>
                    <th class="p-tiny">Bed</th>
                    <th class="p-tiny">Daily Charge</th>
                    <th class="p-tiny">Bed In</th>
                    <th class="p-tiny">Bed Out</th>
                    <th class="p-tiny">Days</th>
                    <th class="p-tiny">Total</th>
                </tr>
            </thead>
            <tbody class="bg-gray-100 text-xs">
                <tr v-for="(wardCharge,idx) in dischargeDetails.patientWardCharges" :key="idx">
                    <td class="p-tiny">{{ wardCharge.ward_Type }}</td>
                    <td class="p-tiny">{{ wardCharge.ward }}</td>
                    <td class="p-tiny">{{ wardCharge.bed }}</td>
                    <td class="p-tiny">{{ wardCharge.daily_Charge | numberFormat }}</td>
                    <td class="p-tiny">{{ wardCharge.bedDateIn | dateFormat }}</td>
                    <td class="p-tiny">{{ wardCharge.bedDateOut | dateFormat }}</td>
                    <td class="p-tiny">{{ wardCharge.days }}</td>
                    <td class="p-tiny">{{ wardCharge.amount | numberFormat }}</td>
                </tr>
                <tr>
                    <td class="p-tiny text-right" colspan="7">Total: </td>
                    <td class="p-tiny" colspan="1">{{ totalBedCharges | numberFormat }}</td>
                </tr>
            </tbody>
        </table>
    </div>
    <div class="w-full p-1 text-center">
        <h5 class="font-bold text-base">Inpatient Charges</h5>
    </div>
    <div class="w-full overflow-auto">
        <table class="table table-bordered table-hover">
            <thead class="bg-blue-500 text-sm text-white">
                <tr>
                    <th class="p-tiny">Date</th>
                    <th class="p-tiny">Item</th>
                    <th class="p-tiny">Consultant</th>
                    <th class="p-tiny">Price</th>
                    <th class="p-tiny">Qty</th>
                    <th class="p-tiny">Total</th>
                    <th class="p-tiny">Paid</th>
                    <th class="p-tiny">Balance</th>
                    <th class="p-tiny">Posted</th>
                </tr>
            </thead>
            <tbody class="text-xs bg-gray-100">
                <tr 
                    v-for="(drugCharges, idx) in dischargeDetails.patientDrugsnService" 
                    :key="idx"
                    :class="drugCharges.isCash == `0` ? `` : `bg-orange-200`">
                    <td class="p-tiny">{{ drugCharges.txnDate | dateFormat }}</td>
                    <td class="p-tiny">{{ drugCharges.service }}</td>
                    <td class="p-tiny">{{ drugCharges.consultant }}</td>
                    <td class="p-tiny">{{ drugCharges.charge | numberFormat }}</td>
                    <td class="p-tiny">{{ drugCharges.quantity }}</td>
                    <td class="p-tiny">{{ drugCharges.grandTotal | numberFormat }}</td>
                    <td class="p-tiny">{{ drugCharges.paid | numberFormat }}</td>
                    <td class="p-tiny">{{ drugCharges.balance | numberFormat }}</td>
                    <td class="p-tiny">{{ drugCharges.billed ? `Yes` : `No` }}</td>
                </tr>
                <tr class="font-medium">
                    <td class="p-tiny text-right" colspan="5">Totals:</td>
                    <td class="p-tiny">{{ totalDrugsAndServices | numberFormat }}</td>
                    <td class="p-tiny">{{ totalPaidAmt | numberFormat }}</td>
                    <td class="p-tiny">{{ totalDSBalance | numberFormat }}</td>
                    <td class="p-tiny"></td>
                </tr>
            </tbody>
        </table>
    </div>
    <div class="w-full p-1 text-center">
        <h5 class="font-bold text-base">Deposits Received</h5>
    </div>
    <div class="w-full overflow-auto">
        <table class="table table-bordered table-hover">
            <thead class="bg-blue-500 text-sm text-white">
                <tr>
                    <th class="p-tiny">Trx Date</th>
                    <th class="p-tiny">Receipt No</th>
                    <th class="p-tiny">Type</th>
                    <th class="p-tiny">Mode</th>
                    <th class="p-tiny">Amount</th>
                    <th class="p-tiny">Allocated</th>
                    <th class="p-tiny">Un-allocated</th>
                    <th class="p-tiny">User</th>
                </tr>
            </thead>
            <tbody class="text-xs bg-gray-100">
                <tr v-for="(patientDeposit, idx) in dischargeDetails.patientsDeposits" :key="idx">
                    <td class="p-tiny">{{ patientDeposit.trxDate | dateFormat }}</td>
                    <td class="p-tiny">{{ patientDeposit.receiptNo }}</td>
                    <td class="p-tiny">{{ patientDeposit.paymentType }}</td>
                    <td class="p-tiny">{{ patientDeposit.mode }}</td>
                    <td class="p-tiny">{{ patientDeposit.depositAmount | numberFormat }}</td>
                    <td class="p-tiny">{{ patientDeposit.amountAllocated | numberFormat }}</td>
                    <td class="p-tiny">{{ patientDeposit.unAllocatedAmount | numberFormat }}</td>
                    <td class="p-tiny">{{patientDeposit.userName}}</td>
                </tr>
                <tr class="font-medium">
                    <td class="p-tiny text-right" colspan="4">Totals:</td>
                    <td class="p-tiny">{{ totalDeposits | numberFormat }}</td>
                    <td class="p-tiny">{{ totalDepositAllocated | numberFormat }}</td>
                    <td class="p-tiny">{{ totalDepositUnallocated | numberFormat }}</td>
                    <td class="p-tiny"></td>
                </tr>
            </tbody>
        </table>
    </div>
    <div class="w-full p-1 text-center">
        <h5 class="font-bold text-base">Payments Received</h5>
    </div>
    <div class="w-full overflow-auto">
        <table class="table table-bordered table-hover">
            <thead class="text-sm bg-blue-500 text-white">
                <tr>
                    <th class="p-tiny">Date</th>
                    <th class="p-tiny">Receipt No</th>
                    <th class="p-tiny">Mode</th>
                    <th class="p-tiny">Paid Amount</th>
                    <th class="p-tiny">Credit Amt</th>
                    <th class="p-tiny">Receipt Amt</th>
                </tr>
            </thead>
            <tbody class="text-xs bg-gray-100">
                <tr v-for="(paymentReceived, idx) in dischargeDetails.patientsPayments" :key="idx">
                    <td class="p-tiny">{{ paymentReceived.date | dateFormat }}</td>
                    <td class="p-tiny">{{ paymentReceived.receipt_No }}</td>
                    <td class="p-tiny">{{ paymentReceived.mode }}</td>
                    <td class="p-tiny">{{ paymentReceived.amount | numberFormat }}</td>
                    <td class="p-tiny">{{ paymentReceived.creditAmount | numberFormat }}</td>
                    <td class="p-tiny">{{ paymentReceived.receiptAmount | numberFormat }}</td>
                </tr>
                <tr class="font-medium">
                    <td class="p-tiny" colspan="4"></td>
                    <td class="p-tiny text-right">Total:</td>
                    <td class="p-tiny">{{ totalPaymentReceived | numberFormat }}</td>
                </tr>
            </tbody>
        </table>
    </div>
    <div class="w-full text-center p-1">
        <h5 class="font-bold text-base">Waivered Charges</h5>
    </div>
    <div class="w-full overflow-auto">
        <table class="table">
            <thead class="bg-blue-500 text-white text-sm">
                <tr>
                    <th class="p-tiny">Date</th>
                    <th class="p-tiny">Bill No</th>
                    <th class="p-tiny">Item</th>
                    <th class="p-tiny">Price</th>
                    <th class="p-tiny">Qty</th>
                    <th class="p-tiny">Total</th>
                    <th class="p-tiny">Waivered</th>
                </tr>
            </thead>
            <tbody class="text-xs bg-gray-100">
                <tr v-for="(waiver,idx) in dischargeDetails.patientsWeivers" :key="idx">
                    <td class="p-tiny">{{ waiver.txnDate | dateFormat }}</td>
                    <td class="p-tiny">{{ waiver.billNo }}</td>
                    <td class="p-tiny">{{ waiver.service }}</td>
                    <td class="p-tiny">{{ waiver.charge | numberFormat }}</td>
                    <td class="p-tiny">{{ waiver.quantity }}</td>
                    <td class="p-tiny">{{ waiver.lineTotal | numberFormat }}</td>
                    <td class="p-tiny">{{ waiver.weiveredAmount | numberFormat }}</td>
                </tr>
                <tr class="font-medium">
                    <td class="p-tiny text-right" colspan="6">Total:</td>
                    <td class="p-tiny">{{ totalWaiver | numberFormat }}</td>
                </tr>
            </tbody>
        </table>
    </div>
    <div class="w-full text-center p-1">
        <h5 class="text-base font-semibold">Bill To Insurance, Companies Or Organization</h5>
    </div>
    <div class="w-full overflow-auto">
        <table class="table">
            <thead class="bg-blue-500 text-white text-sm">
                <tr>
                    <th class="p-tiny">Billed To</th>
                    <th class="p-tiny">Invoice Date</th>
                    <th class="p-tiny">Invoice No</th>
                    <th class="p-tiny">Amount</th>
                </tr>
            </thead>
            <tbody class="bg-gray-100 text-xs">
                <tr v-for="(bill,idx) in dischargeDetails.patientOrganReceipts" :key="idx">
                    <td class="p-tiny">{{ bill.billTo }}</td>
                    <td class="p-tiny">{{ bill.invoiceDate | dateFormat }}</td>
                    <td class="p-tiny">{{ bill.invoiceNo }}</td>
                    <td class="p-tiny">{{ bill.amount | numberFormat }}</td>
                </tr>
                <tr class="font-medium">
                    <td colspan="3" class="p-tiny text-right">Total:</td>
                    <td class="p-tiny">{{ totalOrganizationReceipts | numberFormat }}</td>
                </tr>
            </tbody>
        </table>
    </div>
    <div class="flex flex-col md:flex-row content-start p-1 bg-gray-300 my-2">
        <div class="flex-1">
            <h5 class="font-bold">Total Bill: {{ totalBill | numberFormat }}</h5>
        </div>
        <div class="flex-1">
            <h5 class="font-bold">Payments Made: {{ totalPaidAmt | numberFormat }}</h5>
        </div>
        <div class="flex-1">
            <h5 class="font-bold">Balance: {{ totalBalance | numberFormat }}</h5>
        </div>
    </div>
  </template>
  <template v-slot:modal-footer>
    <button class="btn-danger btn-sm text-xs rounded mr-6" @click="$emit(`closeModal`)">
        <i class="fa fa-times"></i> Close</button>
    <button class="btn-sm btn-info text-xs rounded" @click.prevent="printInterimBill">
        <i class="fa fa-print"></i> Print</button>
  </template>
</tail-modal>
</template>
